var React = require('react');

function TriangleUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},[React.createElement("path",{"fill":"none","d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"fill":"#53647f","d":"M8 6.5l-3 3h6l-3-3z","key":1})])));
}

TriangleUp.defaultProps = {"width":"16","height":"16"};

module.exports = TriangleUp;

TriangleUp.default = TriangleUp;
